import React from 'react';
import {UsePermissions} from "../../hooks/usePermissions";

import {Navigate} from "react-router";
import {SeccionTurnos} from "../../components/SeccionTurnos/SeccionTurnos";
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";

export const LiquidacionPage = () => {
    const [permisos] = UsePermissions();
    return (
        <div className="container-relative">
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>
            <ContainerTable>
                <div className="px-2">
                    {permisos.consultar ? <SeccionTurnos />: <Navigate to="/home"/>}
                </div>

            </ContainerTable>

        </div>
    );
};


